.theme-brand-signnow {
  $royal-blue: #f2f7ff;
  $signnow-blue: #076dbd; // darker shade of brand blue, contrast 4.98:1 on #f2f7ff (WCAG AA)
  $gray-900: #141414; // Assuming this variable exists
  $font-weight-bolder: 700;
  $font-family-graphik: 'Graphik', sans-serif;
  $font-size-small: 12px;
  $font-size-base: 14px;
  $line-height-base: 24px;

  .me-section-call-to-action-type-12 {
    .me-row {
      background: $royal-blue;
      border-radius: 12px;
      padding: 48px 34px 50px 28px;
      overflow: hidden;

      @include desktop {
        padding: 76px 31px 76px 76px;
      }
      
      @include desktop-lg {
        padding: 83px 31px 84px 106px;
      }
    }

    .page-section__column--primary {
      text-align: center;

      @include desktop {
        width: calc(100% - 160px);
        flex-shrink: 0;
        text-align: left;
        z-index: 1;
      }

      @include desktop-lg {
        width: 378px;
        margin-right: 25px;
      }

      @include above($media-desktop) {
        width: 550px;
        margin-right: 38px;
      }
    }

    .page-section__column--illustration {
      position: relative;
      display: none;

      @include desktop {
        display: block;
        padding: 0;
        flex: none;
      }

      @include desktop-lg {
        width: 100%;
        flex: 1 1 0;
      }

      .picture {
        width: 224px;
        height: 402px;
      }

      img {
        display: none;

        @include desktop {
          position: absolute;
          display: block;
          top: 2px;
          right: -64px;
          width: 224px;
          height: 402px;
        }

        @include desktop-lg {
          display: none;
        }
      }

      /* stylelint-disable-next-line selector-id-pattern */
      #animatedSignatureExample {
        display: none;

        @include desktop-lg {
          position: absolute;
          display: block;
          top: -40px;
          right: -39px;
          width: 500px;
          height: 500px;
        }

        @include above($media-desktop) {
          top: -56px;
          right: -8px;
          width: 558px;
          height: 558px;
        }
      }
    }

    .title-illustration {
      .me-text {
        font-size: 10px;
        font-weight: $font-weight-bolder;
        line-height: 16px;
        text-transform: uppercase;
        letter-spacing: 3px;
        text-align: center;
        margin-bottom: 8px;

        @include desktop {
          font-size: $font-size-small;
          line-height: 20px;
          text-align: left;
          margin-bottom: 12px;
        }

        @include above($media-desktop) {
          font-size: $font-size-base;
          line-height: $line-height-base;
        }
      }

      &__blue {
        .me-text {
          color: $signnow-blue;
        }
      }
    }

    .section-subtitle {
      margin-bottom: 24px;
      font-size: 28px;
      line-height: 36px;
      font-family: $font-family-graphik;
      font-weight: $font-weight-bolder;
      color: $gray-900;

      @include desktop {
        margin-bottom: 28px;
        font-size: 32px;
        line-height: 40px;
        text-align: left;
      }

      @include desktop-lg {
        margin-bottom: 24px;
        font-size: 36px;
        line-height: 48px;
      }

      @include above($media-desktop) {
        font-size: 52px;
        line-height: 64px;
      }
    }

    .cta-list__item {
      display: flex;
      margin-bottom: 18px;

      @include desktop {
        margin-bottom: 25px;
      }

      @include desktop-lg {
        margin-bottom: 21px;
      }

      @include above($media-desktop) {
        max-width: 430px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .cta-list {
      padding-left: 0;

      @include above($breakpoint-desktop) {
        padding-right: 40px;
      }
    }
    
    .cta-list__logo {
      display: flex;
      flex-shrink: 0;
      margin-right: 16px;

      @include desktop-lg {
        margin-right: 20px;
      }

      @include above($media-desktop) {
        margin-right: 24px;
      }

      svg {
        width: 44px;
        height: 44px;

        @include desktop {
          width: 40px;
          height: 40px;
          margin-top: -2px;
        }

        @include above($media-desktop) {
          width: 44px;
          height: 44px;
          margin-top: 4px;
        }
      }
    }

    .cta-list__description {
      font-family: $font-family-graphik;
      font-size: 14px;
      line-height: 20px;
      text-align: left;

      @include desktop-lg {
        font-size: 16px;
        line-height: 24px;
      }

      @include above($media-desktop) {
        font-size: 18px;
        line-height: 28px;
      }
    }

    .free-trial__cta {
      display: flex;
      flex-direction: column;
      max-width: 214px;
      margin: 0 auto;
      margin-top: 28px;

      @include desktop {
        flex-direction: row;
        max-width: 444px;
        margin-top: 27px;
        margin-left: 0;
      }

      @include desktop-lg {
        max-width: 100%;
        margin-top: 36px;
      }

      .button {
        min-width: 214px;
        padding-top: 9px;
        padding-bottom: 9px;
        font-size: 16px;
        line-height: 28px;
        font-weight: bold;

        @include desktop-lg {
          min-width: 199px;
        }
      }
    }
  }
}
